function productFilterModule(FilterApi) {
    __ = null;

    this.listen = function () {
        if (!$(".js-product-filters").length) {
            return;
        }

        FilterApi.setRoute($(".js-product-filters").attr("data-filter-route"));

        $("#order-by").on("change", function () {
            FilterApi.submit();
        });

        $("#order-by-name").on("change", function () {
            FilterApi.submit();
        });

        $("#price-filter").on("priceChanged", function () {
            FilterApi.submit();
        });

        FilterApi.changeListener(".js-product-filter-listener");

        $(".js-filter-container").each(function (k, v) {
            var $container = $(this);
            var has_items = $container.find(".js-filter-item").length;
            var no_result = $container.find(".no-new-results").length;

            if (has_items == no_result) {
                $container.hide();
            }
        });
    };
}

module.exports = productFilterModule;
